import InternalSelect from './select';
import Option from './option';
var Select = InternalSelect;
Select.Option = Option;
export default Select;